<script lang="ts">
  // components
  import ResultsTable from './ResultsTable.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  /** @type {import('../types.d').ReadableRace} */
  export let race;

  /** @type {import('../types.d').ReadableDelRace} */
  export let delPartyFeed;

  /** @type {boolean} */
  export let face;

  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  export let captionNote;

  $: caption =
    $race.race_type === 'G' || $race.race_type === 'T' ? `` : $race.seat_name;
    
</script>

<ResultsTable
  {face}
  {crosswalk}
  {caption}
  delCandidates = {delPartyFeed ? $delPartyFeed.candidates: ''}
  raceId={$race.id}
  captionNote={!captionNote ? $race.description: captionNote}
  candidates={$race.candidates}
  totalVotes={$race.total_votes}
  office={$race.office}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp} 
  numOfwinners={$race.number_of_winners}/>
